"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionStatus = void 0;
var TransactionStatus;
(function (TransactionStatus) {
  TransactionStatus[TransactionStatus["TRANSACTION_COMPLETE"] = 200] = "TRANSACTION_COMPLETE";
  TransactionStatus[TransactionStatus["TRANSACTION_IN_PROGRESS"] = 206] = "TRANSACTION_IN_PROGRESS";
  TransactionStatus[TransactionStatus["BAD_INPUT"] = 400] = "BAD_INPUT";
  TransactionStatus[TransactionStatus["NOT_AUTHORISED"] = 403] = "NOT_AUTHORISED";
  TransactionStatus[TransactionStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
  TransactionStatus[TransactionStatus["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));